module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('page-title', {
    attrs: {
      "title": "Autenticação de 2 Fatores"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, _vm._l((_vm.modulesPresets), function(modulePreset) {
    return (_vm.modulesPresets.length) ? _c('div', {
      key: modulePreset,
      staticClass: "l-col-4@md"
    }, [_c('preset-card', {
      attrs: {
        "module": modulePreset
      }
    })], 1) : _vm._e()
  }), 0), _vm._v(" "), _c('panel', [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "target": "_blank",
      "href": _vm.urlLogarme
    }
  }, [_vm._v(_vm._s(_vm.linkTitle))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-657c1e4e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Security/Config.vue
// module id = 3238
// module chunks = 0